<script>
export default {
    name: 'BaseCalendarNavigationPeriod',
};
</script>

<script setup>
import { computed, ref, watch } from 'vue';
import BaseCalendarNavigationPeriodDays from '@/components/base-components/components/calendar/components/navigation/period/days.vue';
import BaseCalendarNavigationPeriodMonths from '@/components/base-components/components/calendar/components/navigation/period/months.vue';
import BaseCalendarNavigationPeriodYears from '@/components/base-components/components/calendar/components/navigation/period/years.vue';
import { PERIOD, PERIOD_LEVELS, VIEW, VIEW_LEVELS } from '@/components/base-components/components/calendar/index.js';

const props = defineProps({
    value:            {
        type: Date,
    },
    view:             {
        type:      String,
        default:   VIEW.MONTH,
        validator: value => Object.values(VIEW).includes(value),
    },
    firstDayOfWeek:   {
        type:    Number,
        default: 1,
    },
    formatterOptions: {
        type: Object,
    },
});

const emit = defineEmits({
    input: null,
});

const date = ref(props.value ?? new Date());

watch(() => props.value, () => {
    date.value = props.value;
});

const periodIndex = ref(0);
const periods = computed(() => Object.keys(PERIOD_LEVELS).filter(period => PERIOD_LEVELS[period] >= VIEW_LEVELS[props.view]));
const period = computed(() => periods.value[periodIndex.value]);
const periodComponent = computed(() => ({
    [PERIOD.DAYS]:   BaseCalendarNavigationPeriodDays,
    [PERIOD.MONTHS]: BaseCalendarNavigationPeriodMonths,
    [PERIOD.YEARS]:  BaseCalendarNavigationPeriodYears,
}[period.value]));

function switchPeriod(step = 1) {
    periodIndex.value = (periodIndex.value + step) % periods.value.length;
}

function onInput(value) {
    date.value = value;

    if (periodIndex.value !== 0) return switchPeriod(-1);

    emit('input', date.value);
}
</script>

<template>
    <component
        class="flex flex-col flex-1 gap-y-2"
        :is="periodComponent"
        :value="date"
        :first-day-of-week="firstDayOfWeek"
        @input="onInput"
    >
        <template #navigation="{ label, goToPrevious, goToNext }">
            <div class="flex items-center justify-between gap-x-0.5">
                <base-button
                    :icon="{
                        name: 'chevron-left'
                    }"
                    size="small"
                    custom-size-class="px-2 py-1.5"
                    text
                    @click="goToPrevious"
                />

                <base-button
                    size="large"
                    custom-size-class="px-2 py-1.5"
                    custom-text-class="text-base"
                    :label="label"
                    :text-transform="false"
                    text
                    @click="switchPeriod(1)"
                />

                <base-button
                    :icon="{
                        name: 'chevron-right'
                    }"
                    size="small"
                    custom-size-class="px-2 py-1.5"
                    text
                    @click="goToNext"
                />
            </div>
        </template>
    </component>
</template>
